<template>
  <div>
    <!-- <h3 class="page-title">Intents</h3> -->

    <div class="card shadow mb-4">
      <!-- Card Header - Dropdown -->
      <div class="card-header py-3 d-flex flex-row align-items-center justify-content-between">
        <h6 class="m-0 font-weight-bold text-primary">Intents</h6>
        <a href="/docs/intents/" target="_blank" class="float-right">
          Documentation
          <i class="fas fa-external-link-alt"></i>
        </a>
      </div>
      <!-- Card Body -->
      <div class="card-body">
        <b-row>
          <b-col class="col-12 col-lg-8">
            <b-row>
              <b-col>
                <h3>Intents</h3>
              </b-col>
              <div class="form-group">
                <b-input-group>
                  <b-input
                    v-model="searchExp"
                    id="intents-search-input"
                    placeholder="Ctrl + F"
                    ref="intents-search-input"
                    @keydown.esc.prevent="searchExp = ''"
                  >
                  </b-input>
                  <b-input-group-append class="mr-3">
                    <b-input-group-text v-if="!searchExp || searchExp.trim().length === 0">
                      <i class="fa fa-search"></i>
                    </b-input-group-text>
                    <b-button
                      v-if="searchExp && searchExp.trim().length > 0"
                      title="Press Esc to clear"
                      @click="searchExp = ''"
                    >
                      <i class="fa fa-backspace"></i>
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
              </div>
              <GlobalEvents @keydown.ctrl.f.prevent="$refs['intents-search-input'].focus()" />
            </b-row>

            <b-alert :show="isNotEvaluated" variant="warning" size="sm" class="text-small">
              <small>NOTE: The model has been updated, but <strong>not retrained</strong>. </small>
            </b-alert>

            <b-alert :show="isImperfectEvaluation" variant="danger" size="sm" class="text-small">
              <small
                >WARNING: Either templates from different intents are clashing or they're ill-defined in another way.</small
              >
              <b-checkbox
                class="mr-2 mt-auto mb-0 d-inline float-right"
                id="ill-only"
                name="ill-only"
                v-model="showOnlyIllDefined"
              >
                <small>Show only flaws</small>
              </b-checkbox>
            </b-alert>

            <b-list-group>
              <b-list-group-item v-if="checkPermissions('/intents', 'PUT')">
                <div v-if="newIntentErr" class="alert alert-danger p-1" role="alert">{{ newIntentErr }}</div>

                <b-input-group class=""
                  ><b-form-input
                    v-model="newIntentName"
                    placeholder="New Intent Name"
                    @keypress.enter="addNewIntent()"
                    class=""
                  />
                  <b-input-group-append>
                    <b-button @click="addNewIntent()" size="sm" variant="primary" class="">Add Intent </b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-list-group-item>

              <b-list-group-item
                v-for="{ negativeIntent, positiveIntent } in filteredIntentsAndPolarized"
                :key="positiveIntent.id"
                v-if="
                  !showOnlyIllDefined ||
                  isNotEvaluated ||
                  hasImperfectEvaluation(evaluation, positiveIntent) ||
                  hasImperfectEvaluation(evaluation, negativeIntent)
                "
                class="p-2"
              >
                <div class="d-flex">
                  <i class="fas fa-quote-left fa-xs m-2"></i>
                  <div
                    v-show="!positiveIntent.id || editIntentId != positiveIntent.id"
                    class="flex-grow-1"
                    @click="toogleExpand(positiveIntent.id)"
                  >
                    <span class="link">{{ positiveIntent.name }}</span>
                  </div>
                  <span v-show="positiveIntent.id && editIntentId == positiveIntent.id" class="flex-grow-1">
                    <input v-model="editIntentNameNewVal" class="rounded ml-2" />
                    <b-button @click="saveIntentName()" size="sm" variant="primary" class="mx-3 box-shadow-2"
                      >Rename & Save</b-button
                    >
                  </span>

                  <div class="float-right d-flex align-items-center">
                    <div
                      v-if="
                        (expanded[positiveIntent.id] || filteredIntentsAndPolarized.length === 1) &&
                        checkPermissions('/intents', 'PUT')
                      "
                      class="d-flex flex-row-reverse mt-1 small"
                      :key="positiveIntent.id + '-' + expanded[positiveIntent.id]"
                      :id="'checkbox-div-' + expanded[positiveIntent.id]"
                    >
                      <b-form-checkbox
                        :id="'polarity-' + positiveIntent.id"
                        :ref="'polarity-' + positiveIntent.id"
                        :checked="Boolean(associatedWithAnother[positiveIntent.id])"
                        @click.native="toggleNegativeIntent(positiveIntent, $event)"
                        switch
                        size="sm"
                        disabled
                        v-b-tooltip.hover
                        title="Enable intent polarity by specifiing positive and negative templates"
                      >
                      </b-form-checkbox>
                      Intent with polarity&nbsp;
                    </div>

                    <div class="evaluation mr-4" v-if="evaluation">
                      <i
                        class="fa fa-check text-gray-400"
                        v-if="isEvaluationOk(evaluation, positiveIntent) && isEvaluationOk(evaluation, negativeIntent)"
                        title="Evaluation is done and ok."
                      ></i>
                      <span v-else>
                        <span
                          v-if="isEvaluationOk(evaluation, negativeIntent) == false"
                          :class="{
                            'badge badge-xs': true,
                            'badge-danger': evaluation[negativeIntent['id']].precision < 1,
                            'badge-light': evaluation[negativeIntent['id']].precision >= 1,
                          }"
                          :title="
                            evaluation[negativeIntent['id']].precision < 1
                              ? 'Templates from other intents are classified into this one [NEG].'
                              : ''
                          "
                        >
                          <small>[NEG] Precision: {{ evaluation[negativeIntent['id']].precision | round(3) }}</small>
                        </span>
                        <span
                          v-if="isEvaluationOk(evaluation, negativeIntent) == false"
                          :class="{
                            'ml-1 badge badge-xxs': true,
                            'badge-danger': evaluation[negativeIntent['id']].recall < 1,
                            'badge-light': evaluation[negativeIntent['id']].recall >= 1,
                          }"
                          :title="evaluation[negativeIntent['id']].recall < 1 ? 'Not all [NEG] templates were recognized.' : ''"
                        >
                          <small>[NEG] Recall: {{ evaluation[negativeIntent['id']].recall | round(3) }}</small>
                        </span>
                        <span
                          v-if="isEvaluationOk(evaluation, positiveIntent) == false"
                          :class="{
                            'badge badge-xs': true,
                            'badge-danger': evaluation[positiveIntent['id']].precision < 1,
                            'badge-light': evaluation[positiveIntent['id']].precision >= 1,
                          }"
                          :title="
                            evaluation[positiveIntent['id']].precision < 1
                              ? 'Templates from other intents are classified into this one.'
                              : ''
                          "
                        >
                          <small>Precision: {{ evaluation[positiveIntent['id']].precision | round(3) }}</small>
                        </span>
                        <span
                          v-if="isEvaluationOk(evaluation, positiveIntent) == false"
                          :class="{
                            'ml-1 badge badge-xxs': true,
                            'badge-danger': evaluation[positiveIntent['id']].recall < 1,
                            'badge-light': evaluation[positiveIntent['id']].recall >= 1,
                          }"
                          :title="evaluation[positiveIntent['id']].recall < 1 ? 'Not all templates were recognized.' : ''"
                        >
                          <small>Recall: {{ evaluation[positiveIntent['id']].recall | round(3) }}</small>
                        </span>
                        <span
                          class="ml-1 badge badge-xs badge-danger"
                          v-if="
                            hasEvaluationTemplateErrors(evaluation, positiveIntent) ||
                            hasEvaluationTemplateErrors(evaluation, negativeIntent)
                          "
                          title="Check the ill templates and amend them, possibly in different intents too."
                        >
                          !
                        </span>
                      </span>
                    </div>
                    <i
                      @click="toogleExpand(positiveIntent.id)"
                      class="fa fa-caret-down ml-3"
                      :class="{
                        'fa-caret-up': expanded[positiveIntent.id],
                        'd-none': filteredIntentsAndPolarized.length === 1,
                      }"
                    ></i>
                    <i
                      class="fa fa-pencil-alt ml-3"
                      @click="
                        () => {
                          editIntentId = positiveIntent.id
                          editIntentNameNewVal = positiveIntent.name
                        }
                      "
                      v-if="checkPermissions('/intents', 'PUT')"
                    ></i>
                    <i
                      class="fa fa-trash-alt ml-2"
                      @click="removeIntent(positiveIntent)"
                      v-if="checkPermissions('/intents', 'PUT')"
                    ></i>
                  </div>
                </div>

                <b-alert
                  v-if="negativeIntent && expanded[positiveIntent.id]"
                  show
                  variant="info"
                  size="sm"
                  class="text-small mt-3"
                >
                  <small>
                    <b>Fill the negative templates first</b>, possitive variants will be auto-generated and can be accepted by
                    the <i>Add Both</i> button.
                  </small>
                </b-alert>

                <div class="d-flex" v-if="expanded[positiveIntent.id] || filteredIntentsAndPolarized.length === 1">
                  <div class="flex-fill col-6" v-if="negativeIntent">
                    <div class="row">
                      <div class="ml-3 mb-2 w-100 mr-2">
                        <vue-tribute :options="tributeOptions" class="input-group input-group-sm">
                          <input
                            placeholder="new negative intent template"
                            :ref="'new-intent-' + negativeIntent.id"
                            @keypress.enter.exact="addBothPolaritiesIntentTemplate(negativeIntent.id, positiveIntent.id)"
                            @keypress.shift.enter="addIntentTemplate(negativeIntent.id)"
                            @focus="updateTributeValues()"
                            @keyup="recalculatePositiveTemplate(negativeIntent.id, positiveIntent.id)"
                            class="form-control"
                          />

                          <b-input-group-append>
                            <b-button
                              @click="addBothPolaritiesIntentTemplate(negativeIntent.id, positiveIntent.id)"
                              size="sm"
                              variant="primary"
                              ref="add-both-btn"
                              >Add Both
                            </b-button>
                            <b-button @click="addIntentTemplate(negativeIntent.id)" size="sm" variant="secondary"
                              >Add Negative
                            </b-button>
                          </b-input-group-append>
                        </vue-tribute>
                      </div>
                    </div>

                    <span class="text-danger" v-html="templateErr[negativeIntent.id]"></span>
                    <ul class="templatesEditor mr-2">
                      <li v-for="(template, i) in negativeIntent.templates" :key="i" :class="{ 'bg-gray-200': i % 2 !== 0 }">
                        <div class="d-flex justify-content-between">
                          <span v-show="!editable[negativeIntent.id + '-' + i]" class="cursor-pointer flex-grow-1 mr-2">
                            <span @click="toogleEditable(negativeIntent.id, i)" class="templateText">
                              <span v-html="getHighligtedIntentTemplate(template)"></span>
                            </span>
                          </span>
                          <span v-if="editable[negativeIntent.id + '-' + i]" class="flex-grow-1 mr-2">
                            <vue-tribute :options="tributeOptions">
                              <input
                                class="templateInput"
                                size="sm"
                                v-model="negativeIntent.templates[i]"
                                @focus="updateTributeValues()"
                                @keyup.enter="toogleEditable(negativeIntent.id, i)"
                                @keyup.esc="cancelEditable(negativeIntent.id, i)"
                              />
                            </vue-tribute>
                          </span>

                          <span
                            ><i
                              class="fa fa-pencil-alt pr-2"
                              @click="toogleEditable(negativeIntent.id, i)"
                              v-if="checkPermissions('/intents', 'PUT')"
                            ></i>
                            <i
                              class="fa fa-trash-alt"
                              @click="removeIntentTemplate(negativeIntent.id, i)"
                              v-if="checkPermissions('/intents', 'PUT')"
                            ></i
                          ></span>
                        </div>
                        <ul v-if="evaluation && evaluation[negativeIntent['id']]">
                          <li
                            v-for="templateEval of evaluation[negativeIntent['id']].data[template]"
                            v-if="!templateEval.is_recognized"
                            :key="templateEval"
                          >
                            <span
                              :class="{
                                'badge badge-xs': true,
                                'badge-warning': templateEval.is_recognized_without_confidence,
                                'badge-danger': !templateEval.is_recognized_without_confidence,
                              }"
                            >
                              {{ templateEval.template }}
                            </span>
                            <small
                              class="badge badge-light badge-xs ml-2 text-gray-600"
                              v-if="!sameTemplates(template, templateEval.template)"
                            >
                              This is an AI augmented template.</small
                            >
                            <small class="badge badge-light badge-xs ml-2" v-if="templateEval.is_recognized_without_confidence">
                              The confidence {{ templateEval.confidence | round(3) }} is below the project threshold.</small
                            >
                            <small
                              class="badge badge-light badge-xs ml-2"
                              v-else-if="templateEval.prediction != null && intentsById[templateEval.prediction]"
                            >
                              Classified into the different intent: <i>{{ intentsById[templateEval.prediction].name }}</i
                              >!</small
                            >
                            <small class="badge badge-light badge-xs ml-2" v-else>Not classified at all!</small>
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </div>
                  <div class="flex-fill">
                    <div class="row" v-if="checkPermissions('/intents', 'PUT')">
                      <div class="ml-3 mr-3 mb-2" :class="{ 'w-100': negativeIntent, 'w-75': !negativeIntent }">
                        <vue-tribute :options="tributeOptions" class="input-group input-group-sm">
                          <input
                            :placeholder="negativeIntent ? 'new positive intent template' : 'new intent template'"
                            :ref="'new-intent-' + positiveIntent.id"
                            @keypress.enter="addIntentTemplate(positiveIntent.id)"
                            @focus="updateTributeValues()"
                            class="form-control"
                          />
                          <b-input-group-append>
                            <b-button @click="addIntentTemplate(positiveIntent.id)" size="sm" variant="primary"
                              >Add Intent Template
                            </b-button>
                          </b-input-group-append>
                        </vue-tribute>
                      </div>
                    </div>

                    <span class="text-danger" v-html="templateErr[positiveIntent.id]"></span>
                    <ul class="templatesEditor mr-2">
                      <li v-for="(template, i) in positiveIntent.templates" :key="i" :class="{ 'bg-gray-200': i % 2 !== 0 }">
                        <div class="d-flex justify-content-between">
                          <span v-show="!editable[positiveIntent.id + '-' + i]" class="cursor-pointer flex-grow-1 mr-2">
                            <span @click="toogleEditable(positiveIntent.id, i)" class="templateText">
                              <span v-html="getHighligtedIntentTemplate(template)"></span>
                            </span>
                          </span>
                          <span v-if="editable[positiveIntent.id + '-' + i]" class="flex-grow-1 mr-2">
                            <vue-tribute :options="tributeOptions">
                              <b-input
                                class="templateInput"
                                size="sm"
                                v-model="positiveIntent.templates[i]"
                                @focus="updateTributeValues()"
                                @keyup.enter="toogleEditable(positiveIntent.id, i)"
                                @keyup.esc="cancelEditable(positiveIntent.id, i)"
                              />
                            </vue-tribute>
                          </span>

                          <span v-if="checkPermissions('/intents', 'PUT')"
                            ><i class="fa fa-pencil-alt pr-2" @click="toogleEditable(positiveIntent.id, i)"></i>
                            <i class="fa fa-trash-alt" @click="removeIntentTemplate(positiveIntent.id, i)"></i
                          ></span>
                        </div>
                        <ul v-if="evaluation && evaluation[positiveIntent['id']]">
                          <li
                            v-for="templateEval of evaluation[positiveIntent['id']].data[template]"
                            v-if="!templateEval.is_recognized"
                            :key="templateEval"
                          >
                            <span
                              :class="{
                                'badge badge-xs': true,
                                'badge-warning': templateEval.is_recognized_without_confidence,
                                'badge-danger': !templateEval.is_recognized_without_confidence,
                              }"
                            >
                              {{ templateEval.template }}
                            </span>
                            <small
                              class="badge badge-light badge-xs ml-2 text-gray-600"
                              v-if="!sameTemplates(template, templateEval.template)"
                            >
                              This is an AI augmented template.</small
                            >
                            <small class="badge badge-light badge-xs ml-2" v-if="templateEval.is_recognized_without_confidence">
                              The confidence {{ templateEval.confidence | round(3) }} is below the project threshold.</small
                            >
                            <small
                              class="badge badge-light badge-xs ml-2"
                              v-else-if="templateEval.prediction != null && intentsById[templateEval.prediction]"
                            >
                              Classified into the different intent: <i>{{ intentsById[templateEval.prediction].name }}</i
                              >!</small
                            >
                            <small class="badge badge-light badge-xs ml-2" v-else>Not classified at all!</small>
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </div>
                </div>
              </b-list-group-item>
            </b-list-group>
            <div class="mt-4 float-right">
              <b-btn variant="secondary" size="sm" class="mx-1" @click="downloadIntentsAsCSV()">Export Intents</b-btn>
              <b-btn variant="secondary" size="sm" class="mx-1" @click="$refs['upload-file'].show()">Import Intents</b-btn>
            </div>
          </b-col>
          <b-col class="col-12 col-lg-4">
            <b-row>
              <h3>Synonyms</h3>
            </b-row>
            <b-alert show dismissible variant="info" size="sm" class="text-small mt-3">
              <small>
                TIP: Use Synonym in Intents template to express multiple possible variants at once. Type
                <i class="fas fa-hashtag"></i> followed by name of synonym.
              </small>
            </b-alert>
            <Synonyms></Synonyms>

            <b-btn id="save-synonyms-primary" variant="primary" class="box-shadow-2 m-3 float-right" @click="saveSynonyms()"
              >Save Synonyms</b-btn
            >
          </b-col>
        </b-row>
      </div>
    </div>

    <b-modal ref="upload-file" size="lg">
      Please select CSV file with two columns:<br />
      <code>intent,template</code> <br />
      <br />
      <h5>For example</h5>
      <code>
        intent,template<br />
        affirm,yes<br />
        affirm,yep<br />
        deny,no<br />
      </code>
      <br />

      <b-form-file
        ref="file"
        placeholder="Choose a CSV file or drop it here..."
        drop-placeholder="Drop file here..."
        @change="handleFileUpload"
      ></b-form-file>
    </b-modal>

    <div class="float-right" style="position: fixed; right: 40px; bottom: 1em">
      <b-btn-group v-if="!reqInFlight">
        <b-btn id="save-button-primary" variant="primary" class="box-shadow-2" @click="train()">Train NLU</b-btn>
        <b-tooltip target="save-button-primary" triggers="hover">
          <small>Ctrl + Shift + S</small>
        </b-tooltip>
      </b-btn-group>
      <div v-if="reqInFlight">
        <b-spinner type="grow" label="Spinning" variant="secondary"></b-spinner>
        <b-spinner type="grow" label="Spinning" class="mx-3" variant="primary"></b-spinner>
        <b-spinner type="grow" label="Spinning" class="mr-3" variant="secondary"></b-spinner>
      </div>

      <GlobalEvents @keydown.ctrl.shift.83="train()" @keydown.ctrl.83.prevent.exact="train()" />
    </div>
  </div>
</template>

<script>
import { mapFields } from 'vuex-map-fields'
import { mapActions } from 'vuex'
import Vue from 'vue'

import Editable from '@/components/Editable/Editable'
import { isDate } from 'util'
import PageSave from '@/components/PageSave/PageSave'
import Synonyms from '@/components/Intents/Synonyms'
import VueTribute from 'vue-tribute'
import { normalizeSync } from 'normalize-diacritics'
import './Intents.scss'

export default {
  name: 'Intents',
  components: {
    editable: Editable,
    PageSave,
    Synonyms,
    VueTribute,
  },
  computed: {
    ...mapFields('rest', ['intents', 'synonyms', 'entities', 'reactions', 'evaluation', 'settings']),
    intentsById() {
      let intentsMap = {}
      this.intents.map((intent) => (intentsMap[intent['id']] = intent))
      return intentsMap
    },
    associatedWithAnother() {
      let associatedMap = {}
      this.intents.map((intent) => {
        const negative = this.hasNegativeCounterIntent(intent)
        if (negative) {
          associatedMap[intent['id']] = negative
        }
      })
      return associatedMap
    },
    isPolarizedAgainstAnother() {
      let isPolarizedMap = {}
      this.intents.map((intent) => {
        const positive = this.hasPositiveCounterIntent(intent)
        if (positive) {
          isPolarizedMap[intent['id']] = positive
        }
      })
      return isPolarizedMap
    },
    synonymsMap() {
      return this.synonyms.map((s) => {
        return { key: s.name, value: s.name }
      })
    },
    filteredIntents() {
      return this.intents.filter(this.searchFilterIntents)
    },
    filteredIntentsAndPolarized() {
      return this.filteredIntents
        .filter((intent) => !this.isPolarizedAgainstAnother[intent['id']])
        .map((intent) => {
          if (this.associatedWithAnother[intent['id']]) {
            return { negativeIntent: this.associatedWithAnother[intent['id']], positiveIntent: intent }
          }
          return { positiveIntent: intent }
        })
    },
    entitiesMap() {
      return this.entities.map((s) => {
        return { key: s.name, value: s.name }
      })
    },
    synonymsNames() {
      return this.synonyms.map((s) => s.name)
    },
    entitiesNames() {
      return this.entities.map((s) => s.name)
    },
    synonymsNamesHashtag() {
      return this.synonyms.map((s) => '#' + s.name)
    },
    entitiesNamesHashtag() {
      return this.entities.map((s) => '@' + s.name)
    },
    normalizedNames() {
      let names = {}
      for (let intent of this.intents) {
        names[intent.id] = { intentName: '', templates: [] }
        names[intent.id].intentName = normalizeSync(intent.name.toLowerCase())
        for (let template of intent.templates) {
          names[intent.id].templates.push(normalizeSync(template.toLowerCase()))
        }
      }
      return names
    },
    normalizedSearchExp() {
      return normalizeSync(this.searchExp.toLowerCase())
    },
    sameTemplates() {
      return (orig, altered) =>
        orig
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '')
          .toLowerCase() ===
        altered
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '')
          .toLowerCase()
    },
    isNotEvaluated() {
      return this.evaluation == null
    },
    isImperfectEvaluation() {
      return this.intents.some((intent) => this.hasImperfectEvaluation(this.evaluation, intent))
    },
  },
  created() {},
  mounted() {
    this.updateTributeValues()
  },
  data() {
    return {
      delayedNegation: null,
      waitingForNegation: false,
      showOnlyIllDefined: false,
      expanded: {},
      editable: {},
      editableOld: {},
      editIntentId: undefined,
      editIntentNameNewVal: undefined,
      newIntentName: undefined,
      newIntentErr: undefined,
      templateErr: {},
      reqInFlight: false,
      tributeOptions: {
        collection: [
          {
            trigger: '#',
            allowSpaces: false,
            autocompleteMode: false,
            values: [],
          },
          {
            trigger: '@',
            allowSpaces: false,
            autocompleteMode: false,
            values: [],
          },
        ],
      },
      searchExp: '',
    }
  },
  methods: {
    ...mapActions('rest', ['getVoices', 'getIntents', 'getEvaluation']),
    hasNegativeCounterIntent(positiveIntent) {
      const filtered = this.intents.filter((intent) => {
        return intent.name == positiveIntent.name + ' [NEG]'
      })
      return filtered[0]
    },
    hasPositiveCounterIntent(negativeIntent) {
      const pos_name = negativeIntent.name.replace(/ \[NEG\]$/, '')
      const filtered = this.intents.filter((intent) => intent.name == pos_name && intent.name != negativeIntent.name)
      return filtered[0]
    },
    toogleExpand(intent) {
      Vue.set(this.expanded, intent, !this.expanded[intent])
      this.$forceUpdate()
    },
    cancelEditable(k, i) {
      let intent = this.intents.find((i) => k === i.id)

      intent.templates[i] = this.editableOld[k + '-' + i]
      Vue.set(this.editable, k + '-' + i, !this.editable[k + '-' + i])
    },
    toogleEditable(k, i) {
      let intent = this.intents.find((i) => k === i.id)

      if (!this.editable[k + '-' + i]) {
        this.editableOld[k + '-' + i] = intent.templates[i]
      } else {
        if (this.editableOld[k + '-' + i] !== intent.templates[i]) {
          if (intent.templates.filter((x) => x === intent.templates[i]).length > 1) {
            this.$notify({
              group: 'app',
              type: 'error',
              title: 'Duplicit intent template',
            })
            return
          }

          this.$store
            .dispatch('rest/insertIntentTemplate', { params: { id: k }, data: { template: intent.templates[i] } })
            .then(() => {
              this.$store.dispatch('rest/deleteIntentTemplate', {
                params: { id: intent.id, template: this.editableOld[k + '-' + i] },
              })

              this.$notify({
                group: 'app',
                type: 'success',
                title: 'Intent template edited',
              })
            })
        }
      }

      Vue.set(this.editable, k + '-' + i, !this.editable[k + '-' + i])
    },
    removeIntent(intent, prompt = undefined, title = undefined) {
      if (!prompt) {
        prompt = `Do You really want to remove intent ${intent.name}?`
      }
      if (!title) {
        title = 'Remove ' + intent.name
      }

      return new Promise((resolve, reject) => {
        this.$bvModal
          .msgBoxConfirm(prompt, {
            title: title,
            size: 'sm',
            buttonSize: 'sm',
            okVariant: 'danger',
            okTitle: 'YES',
            cancelTitle: 'NO',
            footerClass: 'p-2',
            hideHeaderClose: false,
            centered: true,
          })
          .then((value) => {
            if (value === true) {
              let negativeIntent = this.hasNegativeCounterIntent(intent)
              if (negativeIntent) {
                Vue.delete(this.intents, this.intents.indexOf(negativeIntent))
                this.$store.dispatch('rest/deleteIntent', { params: { id: negativeIntent.id } }).then(() => {
                  this.$notify({
                    group: 'app',
                    type: 'success',
                    title: 'Intent deleted',
                  })
                })
              }
              Vue.delete(this.intents, this.intents.indexOf(intent))

              this.$store.dispatch('rest/deleteIntent', { params: { id: intent.id } }).then(() => {
                this.$notify({
                  group: 'app',
                  type: 'success',
                  title: 'Intent deleted',
                })
              })
            }
            resolve(value)
          })
          .catch((err) => {
            console.log(err)
            reject()
          })
      })
    },
    toggleNegativeIntent(intent, $event) {
      if (this.associatedWithAnother[intent['id']]) {
        let done = this.removeIntent(
          this.associatedWithAnother[intent['id']],
          `Do You really want to depolarize the intent ${intent.name} (by removing ${
            this.associatedWithAnother[intent['id']].name
          })?`,
          'Depolarize ' + intent.name
        )
      } else {
        this.newIntentName = intent.name + ' [NEG]'
        this.addNewIntent()

        this.expanded[intent['id']] = true
      }
    },
    addNewIntent() {
      if (!this.newIntentName) {
        this.newIntentErr = 'Intent name cannot be empty'
        return
      }

      if (this.checkDuplicitNames(this.newIntentName)) {
        this.newIntentErr = 'Duplicit intent name'
        return
      }

      this.$store.dispatch('rest/insertIntent', { data: { name: this.newIntentName } }).then((x) => {
        this.intents.unshift({
          id: x.data.id,
          name: this.newIntentName,
          templates: [],
        })

        this.$notify({
          group: 'app',
          type: 'success',
          title: 'New intent added',
        })

        this.expanded = {}
        this.toogleExpand(0)
        this.newIntentName = ''
        this.newIntentErr = undefined
      })
    },
    saveIntentName() {
      let editingIntent = this.intents.find((i) => this.editIntentId === i.id)
      let hasNegativeCounterIntentId = this.hasNegativeCounterIntent(editingIntent)
        ? this.hasNegativeCounterIntent(editingIntent).id
        : false
      let oldName = editingIntent.name
      if (this.editIntentNameNewVal === oldName) {
        // no renaming
        this.editIntentId = undefined
        return
      }
      if (this.checkDuplicitNames(this.editIntentNameNewVal)) {
        return this.$notify({
          group: 'app',
          type: 'error',
          title: 'Duplicit intent name!',
          text: 'Intent name must be unique',
        })
      }

      for (const [i, r] of this.reactions.entries()) {
        for (const [j, intent] of r.intents.entries()) {
          if (intent == oldName) {
            Vue.set(this.reactions[i].intents, j, this.editIntentNameNewVal)
          }
        }
      }

      Vue.set(editingIntent, 'name', this.editIntentNameNewVal)

      if (hasNegativeCounterIntentId) {
        // need to rename negative intent
        this.editIntentId = hasNegativeCounterIntentId
        this.editIntentNameNewVal += ' [NEG]'

        this.saveIntentName()
      } else {
        this.$store
          .dispatch('rest/updateIntent', { params: { id: this.editIntentId }, data: { name: this.editIntentNameNewVal } })
          .then(() => {
            this.$notify({
              group: 'app',
              type: 'success',
              title: 'Intent renamed',
            })
          })

        this.$store.dispatch('rest/updateReactions', { data: this.reactions }).then(() => {
          this.train()
        })
      }

      this.editIntentId = undefined
    },
    checkDuplicitNames(name) {
      return this.intents.filter((x) => x.name == name).length
    },
    checkDuplicitTemplates(name) {
      for (let intent of this.intents) {
        for (let template of intent.templates) {
          if (template.toLowerCase() === name.toLowerCase()) {
            return intent.name
          }
        }
      }
      return false
    },
    removeIntentTemplate(k, templateId) {
      let intent = this.intents.find((i) => k === i.id)

      this.$bvModal
        .msgBoxConfirm(intent.templates[templateId], {
          title: 'Delete intent template?',
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'danger',
          okTitle: 'YES',
          cancelTitle: 'NO',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true,
        })
        .then((value) => {
          if (value === true) {
            this.$store
              .dispatch('rest/deleteIntentTemplate', {
                params: { id: intent.id, template: intent.templates[templateId] },
              })
              .then(() => {
                this.$notify({
                  group: 'app',
                  type: 'success',
                  title: 'Intent template deleted',
                })
              })
            Vue.delete(intent.templates, templateId)
          }
        })
    },
    recalculatePositiveTemplate(nk, pk) {
      const negativeTemplate = this.$refs['new-intent-' + nk][0].value
      if (this.delayedNegation) {
        clearTimeout(this.delayedNegation)
      }
      this.waitingForNegation = true

      this.delayedNegation = setTimeout(() => {
        this.$refs['add-both-btn'][0].innerText = 'Loading...'
        this.$store
          .dispatch('rest/putNegatedTemplate', {
            data: { templates: [negativeTemplate] },
            params: { language: this.settings.language },
          })
          .then((response) => {
            this.$refs['add-both-btn'][0].innerText = 'Add Both'
            if (response.data.templates[0]) {
              this.$refs['new-intent-' + pk][0].value = response.data.templates[0]
            } else {
              this.$refs['new-intent-' + pk][0].value = ''
            }

            if (negativeTemplate == this.$refs['new-intent-' + nk][0].value) {
              // this is last request in a row
              this.waitingForNegation = false
            }
          })
      }, 50)
    },
    addBothPolaritiesIntentTemplate(nk, pk) {
      this.recalculatePositiveTemplate(nk, pk)

      let wait = () => {
        setTimeout(() => {
          if (this.waitingForNegation) {
            wait()
          } else {
            // resolving is done
            this.addIntentTemplate(nk)
            this.$refs['new-intent-' + pk][0].value = this.$refs['new-intent-' + pk][0].value
            this.addIntentTemplate(pk)
            this.$refs['new-intent-' + pk][0].value = ''
          }
        }, 75)
      }

      wait()
    },
    addIntentTemplate(k) {
      if (!this.$refs['new-intent-' + k][0].value) {
        return
      }
      let tempName = this.$refs['new-intent-' + k][0].value
      let duplicitTemplateName = this.checkDuplicitTemplates(tempName)
      if (duplicitTemplateName) {
        let intentName = this.intents.find((i) => k === i.id).name
        if (duplicitTemplateName != intentName) {
          let msg = 'This template name alread exists in the <strong>' + duplicitTemplateName + '</strong> intent'
          Vue.set(this.templateErr, k, msg)
        } else {
          Vue.set(this.templateErr, k, 'This template name already exists.')
        }
        return
      }
      this.intents.find((i) => k === i.id).templates.unshift(tempName)
      this.$refs['new-intent-' + k][0].value = ''
      this.templateErr = {}

      this.$store.dispatch('rest/insertIntentTemplate', { params: { id: k }, data: { template: tempName } }).then(() => {
        this.$notify({
          group: 'app',
          type: 'success',
          title: 'Intent template added',
        })
      })
    },
    updateTributeValues() {
      this.tributeOptions.collection[0].values = this.synonymsMap
      this.tributeOptions.collection[1].values = this.entitiesMap
    },
    getHighligtedIntentTemplate(template) {
      var replaced = template
      if (this.synonyms.length) {
        replaced = replaced.replace(new RegExp(this.synonymsNamesHashtag.join('|'), 'g'), (m, str) => {
          return '<span class="bg-light-info text-gray-700 rounded-sm">' + m + '</span>'
        })
      }

      if (this.entities.length) {
        replaced = replaced.replace(new RegExp(this.entitiesNamesHashtag.join('|'), 'g'), (m, str) => {
          return '<span class="bg-light-warning text-gray-700 rounded-sm">' + m + '</span>'
        })
      }
      return replaced
    },
    updateIntentsAndSynonyms() {
      for (const key in this.editable) {
        this.editable[key] = false
      }
      return Promise.all([
        this.$store.dispatch('rest/updateIntents', { data: this.intents }),
        this.$store.dispatch('rest/updateSynonyms', { data: this.synonyms }),
      ])
    },
    saveSynonyms() {
      this.$store.dispatch('rest/updateSynonyms', { data: this.synonyms })
    },
    getIntentsAndEvaluation() {
      return Promise.all([this.$store.dispatch('rest/getIntents'), this.$store.dispatch('rest/getEvaluation')])
    },
    train() {
      this.reqInFlight = true
      return new Promise((resolve, reject) => {
        this.$store
          .dispatch('rest/runTrain')
          .then((x) => {
            this.$notify({
              group: 'app',
              type: 'success',
              title: 'Successfully trained',
            })
          })
          .finally(() => {
            this.$store.dispatch('rest/getEvaluation')

            this.reqInFlight = false
            resolve()
          })
      })
    },
    searchFilterIntents(intent) {
      if (this.searchExp.trim().length === 0) {
        return true
      }
      let exp = this.normalizedSearchExp
      let nameMatch = this.normalizedNames[intent.id].intentName.includes(exp)
      if (nameMatch) {
        return true
      }
      let templateMatch = false
      for (let template of this.normalizedNames[intent.id].templates) {
        templateMatch = template.includes(exp)
        if (templateMatch) {
          break
        }
      }
      return templateMatch
    },
    isEvaluationOk(evaluation, intent) {
      if (!intent || evaluation === null) {
        return true // no evaluation means there is nothing to complain about
      }
      if (!evaluation[intent['id']]) {
        return null
      }
      if (evaluation[intent['id']].precision < 1 || evaluation[intent['id']].recall < 1) {
        return false
      }
      return !this.hasEvaluationTemplateErrors(evaluation, intent)
    },
    hasEvaluationTemplateErrors(evaluation, intent) {
      if (!intent || !evaluation || !evaluation[intent['id']]) {
        return false
      }
      for (let templateName in evaluation[intent['id']].data) {
        for (let templateEval of evaluation[intent['id']].data[templateName]) {
          if (!templateEval.is_recognized) {
            return true
          }
        }
      }
      return false
    },
    hasImperfectEvaluation(evaluation, intent) {
      if (!intent || !evaluation || !evaluation[intent['id']]) {
        return false
      }
      return evaluation[intent['id']].precision < 1 || evaluation[intent['id']].recall < 1
    },
    downloadIntentsAsCSV() {
      this.$store.dispatch('rest/getIntentsExport', { params: { format: 'csv' } }).then((response) => {
        let link = document.createElement('a')
        link.href = window.URL.createObjectURL(new Blob(['\ufeff', response.data])) // \ufeff is UTF-8 header
        link.download = `intents_${this.axios.defaults.params.project_id}.csv`
        link.click()
      })
    },
    handleFileUpload(e) {
      let formData = new FormData()
      let filenames = []
      for (var f of e.target.files) {
        filenames.push(f.name)
        formData.append('file', f, f.name)
      }

      this.$bvModal
        .msgBoxConfirm('Do You really want to upload files?', {
          title: 'Upload ' + filenames.join(', '),
          size: 'lg',
          buttonSize: 'sm',
          okVariant: 'danger',
          okTitle: 'YES',
          cancelTitle: 'NO',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true,
        })
        .then((value) => {
          if (value === true) {
            this.uploading = true

            this.axios
              .put('v1/intents/import', formData, {
                headers: {
                  'Content-Type': 'multipart/form-data',
                },
              })
              .then(() => {
                this.$notify({
                  group: 'app',
                  type: 'success',
                  title: 'Successfully imported',
                })
                this.$store.dispatch('rest/getIntents')
                this.$notify({
                  group: 'app',
                  type: 'info',
                  title: 'Submitted for NLU train',
                })
                this.train()
              })
              .catch(() => {
                this.$notify({
                  group: 'app',
                  type: 'error',
                  title: 'Error!',
                  text: 'Cannot upload files!',
                })
              })
            this.$refs['upload-file'].hide()
          } else {
            this.$refs.file.reset()
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
  },
  watch: {
    synonyms: function () {
      this.tributeOptions.collection[0].values = this.synonymsMap
    },
    entities: function () {
      this.tributeOptions.collection[1].values = this.entitiesMap
    },
  },
}
</script>
